<template>
  <div :class="isMenu ? 'flex w-screen h-screen transition-all top-0 left-0 ease-out fixed z-50 bg-slate-800/70' : ''">
    <div :class="toggleClass">
      <div class="grid bg-primary text-white gap-1 p-2 mb-2 shadow-md">
        <div class="flex">
          <span class="w-11/12 flex font-semibold">{{ this.profile ? JSON.parse(this.profile || {})?.name || "" : "" }}</span>
          <div class="w-5"><button @click="toggleMenu" class="ico-times w-6 h-6 bg-white"></button></div>
        </div>
        <span class="flex text-xs font-semibold">{{ this.profile ? JSON.parse(this.profile || {})?.email || "" : "" }}</span>
      </div>
      <MenuList :items="routes" />
    </div>
  </div>
</template>

<script>
import MenuList from './Menu/list.vue'
export default {
  name: "MainHeader",
  components: {
    MenuList
  },
  data(){
    return {
      routes: [
        {title: "Dashboard", class: "border-b-2 border-primary hover:bg-primary cursor-pointer hover:text-white hover:font-bold p-2 mx-2", action: () => this.navigate({path: "/"})},
        {title: "Category", class: "border-b-2 border-primary hover:bg-primary cursor-pointer hover:text-white hover:font-bold p-2 mx-2", action: () => this.navigate({path: "/category"})},
        {title: "Content", class: "border-b-2 border-primary hover:bg-primary cursor-pointer hover:text-white hover:font-bold p-2 mx-2", action: () => this.navigate({path: "/content"})},
        {title: "Media", class: "border-b-2 border-primary hover:bg-primary cursor-pointer hover:text-white hover:font-bold p-2 mx-2", action: () => this.navigate({path: "/media"})},
        {title: "Content Template", class: "border-b-2 border-primary hover:bg-primary cursor-pointer hover:text-white hover:font-bold p-2 mx-2", action: () => this.navigate({path: "/content-template"})},
        {title: "Dictionary", class: "border-b-2 border-primary hover:bg-primary cursor-pointer hover:text-white hover:font-bold p-2 mx-2", action: () => this.navigate({path: "/dictionary"})},
        {title: "User Management", class: "border-b-2 border-primary hover:bg-primary cursor-pointer hover:text-white hover:font-bold p-2 mx-2", action: () => this.navigate({path: "/users"})},
        {title: "Logout", class: "hover:bg-primary cursor-pointer hover:text-white hover:font-bold p-2 mx-2", action: this.logout},
      ]
    }
  },
  computed: {
    toggleClass(){
      return  this.isMenu ? "flex-wrap md:w-1/4 bg-white shadow-md" : "hidden"
    }
  },
  methods:{
    navigate(route){
      this.toggleMenu();
      this.$router.push(route);
    },
    logout(){
      this.$store.commit("setToken", null);
      this.$store.commit("setProfile", null);
      this.$store.commit("toggleLogin");
      this.$router.push({name: "login"});
    },

    isVisible(name){
      const profile = JSON.parse(window.localStorage.getItem("profile") || {})
      if(profile){
        let role = "ADMIN";
        if(Object.keys(profile).length > 0){
          if(profile.role?.length > 0){
            role = profile.role[0]
          }
        }
        if(role == "AGENT"){
          return ["Dashboard", "Logout", "Entities"].includes(name)
        }
      }
      return true
    }
  }
}
</script>
